import { Pivot, PivotItem } from '@fluentui/react';
import { useTranslation } from 'react-i18next';

// components
import { PageHeader } from '../../../commons/component/PageHeader/PageHeader';
import StaffListComponent from '../../../components/Persons/StaffList/Staff.List.Component';
import IdentifierTypesListComponent from '../../../components/Persons/IdentifierTypes/IdentifierTypes.List.Component';
import RelationshipTypesListComponent from '../../../components/Persons/RelationshipTypes/RelationshipTypes.List.Component';

export const StaffListPage = () => {
  //useTranslation()
  const [t] = useTranslation();

  return (
    <>
      <PageHeader
        title={t('staffListPage.title', { defaultValue: 'Staff' })}
        subtitle={t('staffListPage.subtitle', {
          defaultValue: 'Administración de las personas que integran el staff'
        })}
      />
      <div className="Content">
        <div className="Section">
          <Pivot>
            <PivotItem headerText={t('staffListPage.tabs.members', { defaultValue: 'Miembros' })}>
              <StaffListComponent />
            </PivotItem>
            <PivotItem
              headerText={t('staffListPage.tabs.identifierTypes', {
                defaultValue: 'Tipos de identificación'
              })}
            >
              <IdentifierTypesListComponent />
            </PivotItem>
            <PivotItem
              headerText={t('staffListPage.tabs.relationshipTypes', { defaultValue: 'Tipos de relación' })}
            >
              <RelationshipTypesListComponent />
            </PivotItem>
          </Pivot>
        </div>
      </div>
    </>
  );
};

export default StaffListPage;
